import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import Pagination from "../../components/Pagination";
import { isValidInput } from "../../utils/validation";
import { useLazyGetAllFormsQuery } from "../../services/forum";
import { APP_ROLE, CONTENT_TYPE, STATUS } from "../../helpers/constants/enums";
import { useParams } from "react-router-dom";

// Generate dummy teaser video data
const generateTeaserData = () =>
  Array.from({ length: 10 }, (_, i) => ({
    id: `teaser-${i + 1}`,
    title: `Teaser Video ${i + 1}`,
    views: Math.floor(Math.random() * 5000),
    likes: Math.floor(Math.random() * 300),
    comments: Math.floor(Math.random() * 100),
    shares: Math.floor(Math.random() * 50),
    tips: Math.floor(Math.random() * 1500),
    subscribers: Math.floor(Math.random() * 1000),
    requests: Math.floor(Math.random() * 20),
    approvals: Math.floor(Math.random() * 50),
    rejections: Math.floor(Math.random() * 10),
    resubmissions: Math.floor(Math.random() * 5),
  }));

const TeaserVideos = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [teasers] = useState(generateTeaserData());
  const [rows, setRows] = useState<any[]>([]);
  const { _id } = useParams();
  const [allVideos] = useLazyGetAllFormsQuery();
  const [totalCount, setTotalCount] = useState<number>(0);
  let totalPages = Math.ceil(totalCount / 10);

  const fetchVideos = async () => {
    try {
      // setIsLoading(true);
      const response = await allVideos({
        page: page,
        search: debouncedSearchTerm,
        createdBy: APP_ROLE.TUTOR,
        contentType: CONTENT_TYPE.TEASER_VIDEO,
        userId: _id,
        // userId: _id as string,
      }).unwrap();
      if (response.statusCode === 200) {
        setRows(response.data?.data);
        setTotalCount(response?.data?.total);
      }
    } catch (error) {
      console.error(error);
    } finally {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, [page, debouncedSearchTerm]);

  return (
    <div>
      <h2 className="mn_hdng">Teaser Videos</h2>

      {/* Summary Section */}
      <Grid container spacing={2}>
        {/* <Grid item xs={12} sm={6} md={4}>
          <Typography className="custom_label">
            Total Teasers: {teasers.length}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography className="custom_label">Total Views: {1200}</Typography>
        </Grid> */}
        {/* <Grid item xs={12} sm={6} md={4}>
          <Typography className="custom_label">
            Total Likes: {totals.likes}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography className="custom_label">
            Total Requests: {totals.comments}
          </Typography>
        </Grid> */}
        {/* <Grid item xs={12} sm={6} md={4}>
          <Typography className="custom_label">
            Total Approvals: {15}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography className="custom_label">
            Total Rejections: {9}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography className="custom_label">
            Total Resubmissions: {12}
          </Typography>
        </Grid> */}
      </Grid>

      <Box className="cards_header" mt={2}>
        <SearchBar
          value={searchTerm}
          searchTerm={searchTerm}
          onCross={() => setSearchTerm("")}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          onChange={(val: any) => {
            if (isValidInput(val.target.value)) {
              setSearchTerm(val.target.value);
            }
          }}
        />
      </Box>

      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Content Status</TableCell>
              <TableCell>Views</TableCell>
              <TableCell>Likes</TableCell>
              <TableCell>Comments</TableCell>
              <TableCell>Shares</TableCell>
              {/* <TableCell>Tips ($)</TableCell> */}
              <TableCell>Save</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{(page - 1) * 10 + index + 1}</TableCell>
                  <TableCell>{row.title}</TableCell>
                  <TableCell>{STATUS[row.contentStatus]}</TableCell>
                  <TableCell>{row.views}</TableCell>
                  <TableCell>{row.likeCount}</TableCell>
                  <TableCell>{row.commentCount}</TableCell>
                  <TableCell>{row.shareCount}</TableCell>
                  {/* <TableCell>${row.tips}</TableCell> */}
                  <TableCell>{row.saveCount}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No teaser videos found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {rows.length > 0 && (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};

export default TeaserVideos;
